<section [fxLayout]="displayMode() === 'default' ? 'row' : 'column'" fxLayoutGap="20px" fxLayoutAlign="start stretch">
  <div [fxFlex]="displayMode() === 'default' ? '50%' : '100%'" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="16px">
    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="6px" fxFlex="1 1 auto">
      <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="8px" fxFlex="1 1 auto">
        <span (click)="selectDevice.emit(device())" class="mve-detail-popup-title fw-600 mve-detail-popup-title-clickable">{{ device()?.name }}</span>
        <ng-content />
      </div>
      <iot-platform-ui-device-info-status [device]="device()" />
    </div>

    <div fxFlex="0 0 auto" fxLayoutAlign="end center">
      <ng-content select="[headerAction]" />
    </div>
  </div>

  <div [fxFlex]="displayMode() === 'default' ? '50%' : '100%'" fxLayout="column">
    <iot-platform-ui-detail-popup-display-property
      property="{{ 'DEVICES.DETAIL_DEVICE_CARD.TYPE' | translate }}"
      value="{{ $safeNavigationMigration(device()?.type) | infoDisplay: '-' : 'family' : 'model' : 'firmware' }}"
    />
    <iot-platform-ui-detail-popup-display-property
      property="{{ 'DEVICES.DETAIL_DEVICE_CARD.IDENTIFIER' | translate }}"
      value="{{ $safeNavigationMigration(device()?.identifier) | infoDisplay }}"
    />
    <iot-platform-ui-detail-popup-display-property
      property="{{ 'DEVICES.DETAIL_DEVICE_CARD.SUPPORT' | translate }}"
      value="{{ $safeNavigationMigration(device()?.communication.support) | infoDisplay }}"
    />
    <iot-platform-ui-detail-popup-display-property
      property="{{ 'DEVICES.DETAIL_DEVICE_CARD.ENDPOINT' | translate }}"
      value="{{ $safeNavigationMigration(device()?.communication.endpoint) | infoDisplay }}"
    />
  </div>
</section>
